import * as types from "../action/types";

const initialState = {
  stats: null,
  recentFeedbacks: { data: [], total: 0 },
  recentAppointments: { data: [], total: 0 },
  loading: false,
  error: null,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.DASHBOARD_REQUEST:
      return { ...state, loading: true, error: null };
    case types.DASHBOARD_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case types.FETCH_COMMAND_CENTER_SUCCESS:
    case types.FETCH_DASHBOARD_SECTION_SUCCESS:
      return { ...state, loading: false, error: null };
    case types.FETCH_DASHBOARD_STATS_SUCCESS:
      return { ...state, loading: false, stats: action.payload };
    case types.FETCH_RECENT_FEEDBACKS_SUCCESS:
      return { ...state, loading: false, recentFeedbacks: action.payload };
    case types.FETCH_RECENT_APPOINTMENTS_SUCCESS:
      return { ...state, loading: false, recentAppointments: action.payload };
    default:
      return state;
  }
};

export default dashboardReducer;
